import "../../App.css";
import React from 'react';
import ProjectItems from "../../ProjectItems";

function Projects() {
  return (
    <>
    <ProjectItems />
    </>
  );
}

export default Projects;
